import cx from 'classnames';
import { DateTime } from 'luxon';
import { HTMLAttributes } from 'react';
import { DateTimeDisplay } from '../../components/DateTimeDisplay';
import { logEvent } from '../../lib/analytics';
import { CalendlyAgentAvailableTimes } from '../../lib/calendly';

interface AgentSchedulingDayProps {
  day: string;
  index: number;
  agentAvailableTimes: CalendlyAgentAvailableTimes;
  calendlyUri: string;
  setCalendlyModalUri: (calendlyUri: string) => void;
  className: HTMLAttributes<HTMLDivElement>['className'];
}

export const AgentSchedulingDay: React.FC<AgentSchedulingDayProps> = ({
  day,
  index,
  agentAvailableTimes,
  calendlyUri,
  setCalendlyModalUri,
  className,
}) => {
  const timeSlots = agentAvailableTimes.days?.[day]?.timeSlots ?? [];
  return (
    <div
      className={cx(
        'flex flex-col justify-start items-stretch px-2',
        'hidden xl:flex',
        {
          'md:flex': index < 3,
          'sm:flex': index < 2,
        },
        className,
      )}
    >
      {timeSlots.map((time, index) => {
        const isMoreButton = index === 3;
        return (
          <button
            key={time.scheduling_url}
            className={cx(
              'my-1 text-gray-700 border-gray-300 rounded hover:opacity-75 text-center whitespace-nowrap w-full',
              { 'border hover:bg-gray-100 p-2': !isMoreButton },
            )}
            onClick={() => {
              const modalUri = isMoreButton
                ? `${calendlyUri}?date=${day}`
                : time.scheduling_url;

              setCalendlyModalUri(modalUri);

              logEvent({
                category: 'Agent Directory',
                name: 'Time slot button clicked',
                calendlyUri: modalUri,
                isMoreButton,
              });
            }}
          >
            {isMoreButton ? (
              <>
                <div>
                  +{agentAvailableTimes.days[day].totalTimeSlots - 3} more
                </div>
                <div className="text-xs">
                  next at{' '}
                  <DateTimeDisplay
                    dateString={time.start_time}
                    format={DateTime.TIME_SIMPLE}
                    displayServerTimezone
                  />
                </div>
              </>
            ) : (
              <DateTimeDisplay
                dateString={time.start_time}
                format={DateTime.TIME_SIMPLE}
                displayServerTimezone
              />
            )}
          </button>
        );
      })}
    </div>
  );
};
